export default __webpack_public_path__ + "static/media/trafficpolice.3bade5ca.jpg";